const FNV_PRIME = 0x01000193
const FNV_OFFSET_BASIS_A = 0x811c9dc5
const FNV_OFFSET_BASIS_B = 0x9747b28c

function fnv1a(value: string, seed: number): string {
  let hash = seed
  for (let index = 0; index < value.length; index += 1) {
    hash = Math.imul(hash ^ value.charCodeAt(index), FNV_PRIME)
  }
  return (hash >>> 0).toString(16).padStart(8, '0')
}

export function hashStorageKeyPart(value: string): string {
  return `${fnv1a(value, FNV_OFFSET_BASIS_A)}${fnv1a(value, FNV_OFFSET_BASIS_B)}`
}
